import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { upsertLogs, setFetching } from 'models/singleAttendeeActivityLog';
import reportFirestore from 'network/reportFirestore';

const AttendeeActivityLogObserver: FC<{ userUuid: string }> = ({ userUuid = '' }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFetching(true));
    const query = reportFirestore
      .collection('BoothActivity')
      .where('user_uuid', '==', userUuid)
      .orderBy('action_at', 'desc');

    const observer = query.onSnapshot(
      (querySnapshot) => {
        dispatch(setFetching(false));
        const freshLogs = querySnapshot.docChanges().filter((change) => change.type === 'added').map((change) => ({
          id: change.doc.id,
          ...change.doc.data(),
        }));
        dispatch(upsertLogs(freshLogs));
      },
      (err) => {
        console.log(`Encountered error: ${err}`);
      },
    );
    return () => {
      observer();
      dispatch(upsertLogs([]));
      dispatch(setFetching(true));
    };
  }, [dispatch, userUuid]);

  return null;
};

export default React.memo(AttendeeActivityLogObserver);
